<template>
    <generic-nav
        dashboard_title="My Property"
        dashboard_route="routes.dashboard"
        :user="user"
        :routes="routes"
        :current="current"
    />
</template>

<script>
import GenericNav from './generic-nav.vue';

export default {
    components: {
        GenericNav,
    },

    props: {
        user: {},
        routes: {},
        current: {},
    },
}
</script>
